import { render, staticRenderFns } from "./ReportSampleView.vue?vue&type=template&id=270f05e2&scoped=true&"
import script from "./ReportSampleView.vue?vue&type=script&lang=js&"
export * from "./ReportSampleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f05e2",
  null
  
)

export default component.exports